<template>
  <div class="container">
    <div
      class="content"
      v-if="
        showHome && showBoard && showPhoneNews && showCleanGover && showTextAll
      "
    >
      <div class="content-left-top">
        <!-- <div class="swiper">
          <div
            class="carousel"
            @mouseenter="stopCarousel"
            @mouseleave="startCarousel"
          >
            <div class="carousel-image">
              <img
                @click="goimgInfo(bannerList[currentIndex])"
                :src="bannerList[currentIndex].annexUrl"
                :alt="bannerList[currentIndex].id"
              />
            </div>
            <div class="indicators">
              <span
                v-for="(item, index) in bannerList"
                :key="index"
                class="indicator"
                :class="{ active: index === currentIndex }"
                @click="currentIndex = index"
              >
                {{ index + 1 }}
              </span>
            </div>
          </div>
          <div class="title">
            {{ bannerList[currentIndex].titleContent }}
          </div>
        </div> -->
        <div class="sec-right">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/sec-tag.png" alt="" />
              <span>{{essayTitleList[0].post}}</span>
            </div>
            <div class="more-box" @click="gengduo(0,0)">
              <div class="more">更多 >></div>
              <!-- <div class="blue-rect"></div> -->
            </div>
          </div>
          <ul class="custom-list warp">
            <li
              v-for="(item, index) in workDynamicsList"
              :key="index"
              class="custom-list-item"
            >
              <div class="li-content">
                <div class="custom-link hover-underline" @click="goInfo(item)">
                  {{ item.titleContent }}
                </div>
                <div>
                  <span v-if="item.isTop==1">置顶 </span> [{{ item.createTime }}]
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="content-right-top mar-bot">
          <div class="right-tab">
            <div class="right-text">{{fileTitleList[0].post}}</div>
            <div class="right-more" @click="gengduo(1,3)">更多>></div>
          </div>
          <ul class="custom-list">
            <li
              v-for="(item, index) in workInstructionsList"
              :key="index"
            >
              <div class="li-content wid">
                <div class="custom-link hover-underline" @click="download(item)">
                  {{ item.titleContent }}
                </div>
                <!-- <div>[{{ item.createTime }}]</div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>


      <div class="content-left-sec">
        <div class="column">
          <div class="content-left-sec-left">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../../assets/images/sec-tag.png" alt="" />
                <span>{{essayTitleList[1].post}}</span>
              </div>
              <div class="more-box" @click="gengduo(0,1)">
                <div class="more">更多 >></div>
                <!-- <div class="blue-rect"></div> -->
              </div>
            </div>
            <ul class="custom-list warp">
              <li
                v-for="(item, index) in specialIssueNewsletterList"
                :key="index"
                class="custom-list-item"
              >
                <div class="li-content">
                  <div class="custom-link hover-underline" @click="goInfo(item)">
                    {{ item.titleContent }}
                  </div>
                  <div>
                    <span v-if="item.isTop==1">置顶 </span> [{{ item.createTime }}]
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-left-sec-left">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../../assets/images/sec-tag.png" alt="" />
                <span>{{essayTitleList[2].post}}</span>
              </div>
              <div class="more-box" @click="gengduo(0,2)">
                <div class="more">更多 >></div>
                <!-- <div class="blue-rect"></div> -->
              </div>
            </div>
            <ul class="custom-list warp">
              <li
                v-for="(item, index) in discussionExchangeList"
                :key="index"
                class="custom-list-item"
              >
                <div class="li-content">
                  <div class="custom-link hover-underline" @click="goInfo(item)">
                    {{ item.titleContent }}
                  </div>
                  <div>
                    <span v-if="item.isTop==1">置顶 </span> [{{ item.createTime }}]
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="content-left-sec-left" style="margin-left: 12px">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/sec-tag.png" alt="" />
              <span>信息动态</span>
            </div>
            <div class="more-box" @click="gengduo(3)">
              <div class="more">更多 >></div>
            </div>
          </div>
          <ul class="custom-list">
            <li
              @click="goInfo(item)"
              v-for="(item, index) in fourList"
              :key="index"
            >
              <div class="li-content">
                <div class="custom-link hover-underline">
                  {{ item.titleContent }}
                </div>
                <div>
                  <span v-if="item.isTop==1">置顶 </span> [{{ item.createTime }}]
                </div>
              </div>
            </li>
          </ul>
        </div> -->
        <!-- 简报专刊 -->
        <div class="content-right-sec mar-bot" style="margin-left: 12px">
          <div class="right-tab">
            <div class="right-text">{{fileTitleList[1].post}}</div>
            <div class="right-more" @click="gengduo(1,4)">更多>></div>
          </div>
          <ul class="custom-list">
            <li
              v-for="(item, index) in learningCornerList"
              :key="index"
            >
              <div class="li-content wid">
                <div class="custom-link hover-underline" @click="download(item)">
                  {{ item.titleContent }}
                </div>
                <!-- <div>[{{ item.createTime }}]</div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="swiper-img">
        <div class="sec-right-title" style="margin-bottom: 16px;">
              <div class="tag">
                <img src="../../../assets/images/sec-tag-plus.png" alt="" />
                <span>学习掠影</span>
              </div>
            </div>
        <div class="carousel-inner">
          <vue-j-scroll
            class="list-style"
            :steep="1"
            scrollDirection="left"
            :isRoller="true"
            :data="imgList"
            :rollerScrollDistance="50"
          >
            <div>
              <img
                v-for="(item, index) in imgList"
                :key="'t' + index"
                :src="item.annexUrl"
                @click="goimgInfo(item)"
                alt=""
              />
            </div>
          </vue-j-scroll>
        </div>
      </div>
      <div class="bottom-btn">
        <div class="btn" v-for="(item, index) in LinkList" @click="gowaizhan(item.fileUrl)">
          <div class="btn-box hover-underline">
            <img :src="item.annexUrl" alt="" />
            <div class="btn-text" style="margin-top: 11px">{{item.titleContent}}</div>
          </div>
        </div>
        <div class="btn" @click="gowaizhan('/')">
          <div class="btn-box hover-underline">
            <img
              src="../../../assets/images/board.png"
              style="width: 36px; height: 38px"
              alt=""
            />
            <div class="btn-text">留言板</div>
          </div>
        </div>
      </div>
      <div class="is-show" v-show="isShowImg">
        <span>消防救援局</span><span>芜湖消防救援</span><span>消防救援局</span
        ><span>芜湖消防救援</span>
      </div>
      <div class="is-show-img">
        <img
          src="../../../assets/images/is-show.png"
          alt=""
          @click="isShowImg = !isShowImg"
        />
      </div>
      <div class="linkage">
        <div class="linkage-left">
          <div class="linkage-box">
            <img src="../../../assets/images/arrow.png" alt="" />
            <div class="linkage-text">国家消防救援局</div>
          </div>
          <div class="linkage-box">
            <img src="../../../assets/images/arrow.png" alt="" />
            <div class="linkage-text">总队单位</div>
          </div>
          <div class="linkage-box">
            <img src="../../../assets/images/arrow.png" alt="" />
            <div class="linkage-text">本省支队网</div>
          </div>
          <!-- <div class="linkage-box">
            <img src="../../../assets/images/arrow.png" alt="" />
            <div class="linkage-text">业务系统</div>
          </div> -->
        </div>
        <!--  -->
      </div>
      <div style="width: 100%; height: 164px; margin: 0 auto">
        <img
          src="../../../assets/images/bottom-img.png"
          alt=""
          style="width: 100%; height: 164px"
        />
      </div>
    </div>

    <!-- 隐藏框 -->

    <div v-if="!showHome">
      <important-news :workId="workId" :winTitle="winTitle" :columnType="encolumnType" :type="entype" @setCilck="setShow(true)"></important-news>
    </div>
    <div v-if="!showPhoneNews">
      <photo-news @setCilck="setShow(true)"></photo-news>
    </div>
    <div v-if="!showCleanGover">
      <clean-gover :winTitle="winTitle" :imgid="imgid" @setCilck="setShow(true)"></clean-gover>
    </div>
    <div v-if="!showTextAll">
      <text-all :ids="ids" :winTitle="winTitle" @setCilck="setShow(true)"></text-all>
    </div>
    <div class="brx">
      <div class="xian"></div>
    </div>
    <div class="bottom-info">
      <div class="bottom-box">
        <div>Copyright © 池州消防支队 allright reserved</div>
        <div style="color: #2b56ac">【后台管理】</div>
        
      </div>
    </div>
  </div>
</template>

<script>
import ImportantNews from "./compotents/ImportantNews.vue";
// import PhotoNews from "./compotents/PhotoNews.vue";
import CleanGover from "./compotents/CleanGover.vue";
import TextAll from "./compotents/TextAll.vue";
import { listspecial } from "@/api/columnWindow";
import { dutyList } from "@/api/SpecialWork";
export default {
  components: {
    ImportantNews,
    // PhotoNews,
    CleanGover,
    TextAll,
  },
  data() {
    return {
      elevenShow: true,
      showHome: true,
      currentPage: "",
      showBoard: true,
      showPhoneNews: true,
      showCleanGover: true,
      showTextAll: true,
      eletype: 0,
      date: "",
      title: "",
      currentIndex: 0,
      interval: null,
      isShowImg: false,
      
      
      images: [],
      search: "",
      serachFrom: {
        pageNum: 1,
        pageSize: 30,
      },
      oneList: [],
      twoList: [],
      threeList: [],
      fourList: [],
      fiveList: [],
      sixList: [],
      sevenList: [],
      eightList: [],
      nineList: [],
      swriperList: [],
      bannerList: [],
      tableList: [],
      workDynamicsList: [],
      specialIssueNewsletterList: [],
      discussionExchangeList: [],
      workInstructionsList: [],
      learningCornerList: [],
      imgList: [],
      LinkList: [],
      ids:'',
      imgid:'',
      workId: '',
      winTitle: '',
      encolumnType: '',
      entype: '',
      essayTitleList: [],
      fileTitleList: [],
    };
  },
  created() {
    if(this.$route.query.param){
      this.workId = JSON.parse(this.$route.query.param)
      // if(this.workId == 4){
      //   document.title = "支队政工网";
      //   this.winTitle = "支队政工网";
      // }else if(this.workId == 5){
      //   document.title = "灭火救援网";
      //   this.winTitle = "灭火救援网";
      // }else if(this.workId == 6){
      //   document.title = "支队纪委";
      //   this.winTitle = "支队纪委";
      // }else if(this.workId == 7){
      //   document.title = "工会";
      //   this.winTitle = "工会";
      // }
    }
    if(this.$route.query.columnType&&this.$route.query.type){
      this.showHome = !this.showHome;
      this.encolumnType = this.$route.query.columnType;
      this.entype = this.$route.query.type;
    }
    console.log(this.workId,'this.workId');
    this.dutyList(4)
    this.dutyList(5)
    this.getlistspecial(0,0);
    this.getlistspecial(0,1);
    this.getlistspecial(0,2);
    this.getlistspecial(1,3);
    this.getlistspecial(1,4);
    this.getlistspecial(2);
    this.getlistspecial(3);
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.ids = params.get('ids');
    this.imgid = params.get('imgid');
    if(params.get('winTitle')){
      this.winTitle = params.get('winTitle');
    }

    if(this.ids) {      
      console.log(this.winTitle,'this.winTitle');
      
      this.showTextAll = !this.showTextAll
    }
    if(this.imgid) {      
      this.showCleanGover = !this.showCleanGover
    }
    this.getDate();
    this.startCarousel();
  },
  methods: {
    async dutyList(type) {
      const query = {
        pageNum: 1,
        pageSize: 10,
        type:type
      }
      const  res = await dutyList(query)
      if(res.data.code == 200){
        if(type %2 == 0){
          this.essayTitleList = res.data.data.list
          console.log(this.essayTitleList,'this.essayTitleList');
        }else{
          this.fileTitleList = res.data.data.list
          console.log(this.fileTitleList,'this.fileTitleList');
        }
      }
    },
    download(item){
      window.open(item.fileUrl, "_blank");
    },
    gowaizhan(url) {
      if(url=='/'){
        url = '/?showBoard=false'
      }
      window.open(url, "_blank");
    },
    goInfo(item) {
        // 使用window.open方法在新窗口或选项卡中打开链接
        const ids = item.id
        const url = `/columnWindow?ids=${encodeURIComponent(ids)}
        &winTitle=${encodeURIComponent(this.winTitle)}&param=${this.workId}`;
        window.open(url, "_blank");
    },
    goimgInfo(item) {
        // 使用window.open方法在新窗口或选项卡中打开链接
        const ids = item.id
        const url = `/columnWindow?imgid=${encodeURIComponent(ids)}
        &winTitle=${encodeURIComponent(this.winTitle)}&param=${this.workId}`;
        window.open(url, "_blank");
    },
    getlistspecial(columnType,type) {
      if(type >= 0){
        this.serachFrom.type = type
      }else{
        this.serachFrom.type = ''
      }
      this.serachFrom.columnType = columnType
      this.serachFrom.status = 4
      this.serachFrom.workId = this.workId
      listspecial(this.serachFrom).then((res) => {
        this.tableList = res.data.data.list;
        if (this.tableList) {
          this.tableList = this.tableList.map((item) => {
            item.createTime = item.createTime.slice(5, 10);
            if (item.titleContent) {
              if (item.titleContent.length > 16) {
                item.titleContent = item.titleContent.slice(0, 16) + "...";
              }
            }
            return item;
          });
        }
        if (this.tableList) {
          switch (columnType) {
              case 0:
                if(type == 0) this.workDynamicsList = this.tableList.splice(0,18)
                if(type == 1) this.specialIssueNewsletterList = this.tableList.splice(0,10)
                if(type == 2) this.discussionExchangeList = this.tableList.splice(0,10)
              break;
              case 1:
                if(type == 3) this.workInstructionsList = this.tableList.splice(0,13)
                if(type == 4) this.learningCornerList = this.tableList.splice(0,19)
              break;
              case 2:
                this.imgList = this.tableList
              break;
              case 3:
                this.LinkList = this.tableList
              break;
            default:
              break;
          }
        }
      });
    },
    bannerBtn() {
      this.bannerobj = this.bannerList[this.currentIndex];
      this.showCleanGover = !this.showCleanGover;
    },
    swriperBtn(item) {
      this.showCleanGover = !this.showCleanGover;
      this.bannerobj = item;
    },
    textBtn(item) {
      this.textobj = item;
      this.showTextAll = !this.showTextAll;
    },
    setShow(value) {
      this.showHome = value;
      this.showBoard = value;
      this.showPhoneNews = value;
      this.showCleanGover = value;
      this.showTextAll = value;
    },
    gengduo(columnType,type) {
      const url = `/columnWindow?columnType=${encodeURIComponent(columnType)}&type=${encodeURIComponent(type)}&param=${encodeURIComponent(this.workId)}`;
      window.open(url, "_blank");
      // this.showHome = !this.showHome;
      // this.encolumnType = columnType;
      // this.entype = type;
    },

    getDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const date = today.getDate();
      const weekday = today.getDay();
      const weekdays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekdayName = weekdays[weekday];
      console.log(`今天是${year}年${month}月${date}日，${weekdayName}`);
      this.date = `${year}年${month}月${date}日   ${weekdayName}`;
    },
    nextSlide() {
      this.currentIndex++;
      if (this.currentIndex >= this.bannerList.length) {
        this.currentIndex = 0;
      }
    },
    startCarousel() {
      this.interval = setInterval(this.nextSlide, 3000);
    },
    stopCarousel() {
      clearInterval(this.interval);
    },

    doSearch() {},
  },
  beforeDestroy() {
    this.stopCarousel();
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 1120px;
  margin: 0 auto;
  background: #fff;
}
.indicator {
  color: #fff;
}
.top {
  width: 1120px;
  height: 277px;
  margin: 0 auto;

  img {
    width: 1120px;
    height: 277px;
  }
}

.banner {
  width: 1120px;
  height: 57px;
  margin: 0 auto;
  margin-top: 4px;

  img {
    width: 1120px;
    height: 57px;
  }
}

.date {
  width: 1120px;
  margin: 16px auto;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .red {
    color: #e71111;
  }

  .linkage-right {
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      width: 110px;
      height: 24px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #2b56ac;
    }

    .no-outline-input {
      outline: none;
    }

    .no-outline-input:focus {
      border-color: #2b56ac;
    }

    .button {
      width: 24px;
      height: 28px;
      background: #2b56ac;
      border-radius: 0px 4px 4px 0px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 11px;
        height: 12px;
      }
    }
  }
}

.custom-list {
  list-style-type: none;
  padding: 0 12px;
}
.warp{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.custom-list-item {
  flex: 1 0 46%;
  max-width: 46%;
}
.custom-list li {
  position: relative;
  padding-left: 18px;
  // margin: 10px 0;
}

.custom-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: #c1c5cd;
  border-radius: 50%;
}

.li-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  span {
    display: inline-block;
    width: 40px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #ffdfdf;
    border-radius: 4px;
    font-size: 10px;
    color: #cc0000;
    // margin-left: 10px;
  }
}

.custom-link {
  color: inherit;
  text-decoration: none;
}

.wid {
}

.content {
  width: 100%;
  margin: 0 auto;
  // display: flex;
  // justify-content: flex-start;
  margin-top: 12px;

  .content-left-top {
    width: 100%;
    height: 292px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .swiper {
    width: 38%;
    height: 243px;

    .carousel {
      position: relative;
      width: 100%;
      height: 218px;
      overflow: hidden;
    }

    .carousel-image img {
      width: 100%;
      height: 218px;
    }

    .indicators {
      position: absolute;
      right: 10px;
      bottom: 10px;
      display: flex;
    }

    .indicators span {
      display: inline-block;
      width: 17px;
      height: 17px;
      margin: 0 5px;
      background: #9a8880;
      text-align: center;
      line-height: 17px;
      cursor: pointer;
    }

    .indicators span.active {
      background: #e4730d;
    }
  }

  .title {
    width: 100%;
    height: 25px;
    text-align: center;
    background: #5f5f5f;
    color: #fff;
  }

  .sec-right {
    width: 76%;
    height: 255px;
    // margin-left: 12px;

    .important-news-text {
      width: 380px;
      text-align: center;
      margin-top: 10px;
    }
  }

  .sec-right-title {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .more-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 2px;
    color: #2e5bb6;
    cursor: pointer;
  }

  // .more {
  //     // margin-right: -2px;
  // }

  .blue-rect {
    width: 2px;
    height: 30px;
    background-color: #2851a4;
  }

  .tag {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      height: 30px;
      margin-top: 3px;
    }

    span {
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      // width: 64px;
      height: 24px;
      top: 6px;
      left: 16px;
      position: absolute;
    }
  }

  .long-tag {
    img {
      width: 772px;
    }
  }

  .important-news-text {
    font-weight: bold;
    font-size: 14px;
    color: #e71111;
  }

  .content-left-sec {
    width: 100%;
    margin-top: 12px;
    height: 384px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .content-left-sec-left {
    height: 180px;
    width: 100%;
  }

  .thr {
    width: 772px;
  }

  .content-left-thr {
    width: 772px;
    height: 222px;
  }

  .my-li {
    margin: 8px 0;
  }
  .column{
    width: 76%;
    justify-content: space-between;
    min-height: 374px;
    display: flex;
    flex-direction: column;

  }
  .content-left-thr-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content-left-right {
    margin-left: 14px;
  }

  .content-left-thr-left {
    width: 361px;
    height: 200px;

    .row {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    .row-right {
      width: 301px;
      margin-left: 8px;
    }

    img {
      margin-top: 6px;
      width: 64px;
      height: 24px;
    }
  }

  .content-left-four {
    width: 772px;
    height: 164px;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mar-bot {
    margin-bottom: 7px;
  }

  .content-right-top {
    width: 26%;
    height: 255px;
    margin-left: 12px;

    .top-text {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .title {
      width: 104px;
      height: 30px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
      background: linear-gradient(to bottom, #3364c5, #1e4188);
    }

    .blue {
      font-weight: bold;
      font-size: 16px;
      color: #2b56ac;
      margin-left: 20px;
    }
  }

  .content-right-sec {
    width: 26%;
    height: 100%;
    // height: 384px;
  }

  .right-tab {
    width: 100%;
    height: 30px;
    color: #ffffff;
    padding: 0 12px;
    background: linear-gradient(to bottom right, #628fe8, #214690);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .work-box {
    width: 248px;
    height: 151px;
    margin-left: 12px;
  }

  .work {
    width: 228px;
    height: 26px;
    font-size: 14px;
    text-align: center;
    line-height: 26px;
    color: #333333;
    margin: 10px 0;
    border: 0.5px dashed #dadada;
    background: linear-gradient(to bottom, #ffffff, #eeeeee);
  }

  .content-right-five {
    width: 248px;
    height: 176px;
  }

  .right-text {
    font-weight: bold;
    font-size: 16px;
  }

  .right-more {
    font-size: 12px;
    cursor: pointer;
  }
}

.swiper-img {
  width: 100%;
  min-height: 160px;
  margin: 0 auto;
  margin-top: 16px;

  .carousel-inner img {
    width: 210px;
    height: 140px;
    margin: 0 10px;
  }
}
.brx {
  width: 100%;
  display: flex;
  justify-content: center;
}
.xian {
  width: 100%;
  height: 2px;
  background: #2b56ac;
}
.bottom-btn {
  width: 1120px;
  height: 154px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .btn {
    width: 96px;
    height: 110px;
    background: #ffffff;
    box-shadow: 2px 2px 12px 1px rgba(153, 153, 153, 0.24);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn-box {
      text-align: center;
    }

    img {
      width: 40px;
      height: 30px;
    }

    .btn-text {
      margin-top: 5px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.is-show {
  width: 100%;
  height: 72px;
  border: 1px solid #2e5bb6;
  padding: 14px 0 0 14px;
  box-sizing: border-box;
  margin-top: -72px;
  margin-bottom: -10px;
  position: relative;
  background: #fff;
  z-index: 2;
  margin: 0 auto;

  span {
    color: #2e5bb6;
    margin-right: 28px;
  }
}

.is-show-img {
  cursor: pointer;
  width: 100%;
  height: 4px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 4px;
  }
}

.linkage {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  margin: 0 auto;
  box-sizing: border-box;

  .linkage-left {
    width: 730px;
    display: flex;
    justify-content: center;
    align-items: center;

    .linkage-box {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 23px;
        height: 20px;
        margin-right: 16px;
      }
    }
  }

  .linkage-text {
    font-weight: bold;
    font-size: 16px;
    color: #2b56ac;
    margin-right: 60px;
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  // background: #0E67AB;
  font-size: 14px;
  color: #333333;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
</style>
